import ComparisonPageTestimonial from "@components/ComparisonPageV2/ComparisonPageTestimonial";
import HeroButton from "@components/HeroButton";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";

import YellowCTAhref from "@components/yellowCTAhref";
import Image from "next/image";
import { FC } from "react";

const NewWatiComparison: FC = () => {
    const WatiComparison = [
        { title: "Additional Users", gallabox: "$15 per month", wati: "$30 per month" },
        { title: "Chatbot Flows", gallabox: "No Limits", wati: "200" },
        { title: "Chatbot Features", gallabox: "Advanced with bot connectors and utilities", wati: "Keyword based bot flows" },
        { title: "Annual Price Plan", gallabox: "$40 per month", wati: "$49 per month" },
        { title: "Support", gallabox: "Ticketing, Email", wati: "Ticketing" },
    ];

    const firstChatbot = [
        {
            txt: "Improve ROI by channeling man-hours in more productive avenues",
            img: "fc-1",
        },
        {
            txt: "Eliminate complex steps and build a no-code chatbot",
            img: "fc-2",
        },
        {
            txt: "Ready to integrate templates reduces the developer effort",
            img: "fc-3",
        },
    ];
    const betterConversions = [
        {
            txt: "Assign team queries and customer intent to your team at the click of a button",
            img: "bc-1",
        },
        {
            txt: "Work from anywhere and lose no critical customer enquiry",
            img: "bc-2",
        },
        {
            txt: "Enhance your customer response time by easily assigning the enquiries to the relevant agent",
            img: "bc-3",
        },
    ];
    const waBroadcast = [
        {
            txt: "Reach a wide range of audience and see higher engagement in your campaigns.",
            img: "wb-1",
        },
        {
            txt: "Integrate with your CRM and run customized user journey campaigns or gather customer feedback",
            img: "wb-2",
        },
        {
            txt: "Use Gallabox in-built templates and save time spent to create and manage broadcast campaigns.",
            img: "wb-3",
        },
    ];
    const barScoreOne = [
        {
            title: "Meets Requirements",
            gallabox: 8.9,
            wati: 8.8,
        },
        {
            title: "Ease of Use",
            gallabox: 9.1,
            wati: 9.0,
        },
        {
            title: "Ease of Setup",
            gallabox: 8.8,
            wati: 8.7,
        },
        {
            title: "Support",
            gallabox: 9.6,
            wati: 8.8,
        },
    ];

    const barScoreTwo = [
        {
            title: "Personalization",
            gallabox: 8.9,
            wati: 8.4,
        },
        {
            title: "Omnichannel",
            gallabox: 9.3,
            wati: 7.5,
        },
        {
            title: "Contextual Engagement",
            gallabox: 9.2,
            wati: 8.2,
        },
        {
            title: "Proactive Engagement",
            gallabox: 9.1,
            wati: 8.0,
        },
    ];

    return (
        <NewLayout
            title="Best Wati Alternative | WhatsApp Marketing Automation | Gallabox"
            description="Searching for the best Wati alternative for your WhatsApp marketing automation? Try Gallabox - the #1 alternative to Wati."
            canonical="https://gallabox.com/best-wati-alternative"
            ogAttributes={{ image: "/wati-og.jpg" }}
        >
            <div className="px-5" style={{ background: "#F6FbFF" }}>
                <header className="md:pt-20 pb-0 md:pb-8 max-w-6xl mx-auto wati">
                    <div className="flex  flex-wrap md:flex-nowrap  justify-center md:justify-between">
                        <div className="md:w-3/6 flex flex-col my-10 wa-mobile-a">
                            <span className="">
                                <h1 className="text-5xl font-bold mb-0 text-blue-500">
                                    <span className="block">Using Wati?</span>
                                    <span className="block">Try Gallabox instead.</span>
                                </h1>
                                <span className=" text-4xl font-medium text-center md:text-left hidden md:inline" style={{ color: "black" }}>
                                    Scale faster with WhatsApp
                                </span>
                                <span className="text-base md:text-xl font-normal block max-w-xl mb-6 my-3 md:my-10 text-center md:text-left" style={{ color: "#444444" }}>
                                    Customize your chatbot and interact with your customers directly, and at a lesser price.
                                </span>
                            </span>
                            <HeroButton buttontext="7-day free trial" />
                        </div>
                        <div className="header-img-section">
                            <div className="wati-header-img mt-8 md:mt-24 ">
                                <Image alt="hero image" className="img" src="https://assets.gallabox.com/gb-home/new-wati/new-wati-header.png" layout="fill" />
                            </div>
                        </div>
                    </div>
                </header>

                <div className="lg:max-w-7xl mx-auto client-logos pt-2 md:pt-0">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>

                <section className="mt-28 md:mt-36">
                    <ComparisonPageTestimonial
                        mainTitle="Testimonials"
                        quotationText='"Complex to Simple Chat bot - One solution for all"'
                        question="What do you like best about Gallabox?"
                        description={
                            <p className="text-gray-700 text-sm md:text-lg font-normal px-9 md:px-0">
                                We have an extremely complex system that required a chatbot that could easily integrate with our system. Gallabox has made complex API integrations
                                so smoother that we continue to use it as a key channel for acquiring and retaining customers.{" "}
                                <span style={{ color: "#2E90FA" }} className="font-bold">
                                    We evaluated WATI and Interakt and realized that Gallabox stands out
                                </span>{" "}
                                as we could integrate deeper with WhatsApp for our entire customer lifecycle. We also get WhatsApp APIs which we can integrate easily for more
                                customization. The best part is that all this is at par in pricing with other players and I don&apos;t need to think twice about its
                                cost-effectiveness.
                            </p>
                        }
                        founderName="Manmeet Kalra"
                        companyName="Founder - Zeigen"
                        starFill={["full", "full", "full", "full", "half"]}
                    />
                </section>
                <section className="mt-28">
                    <h2 className="text-center mx-auto text-2xl md:text-5xl">
                        <span className="relative w-fit inline-block ">
                            <span className="relative w-fit inline-block">
                                Save 102% of cost
                                <svg
                                    className="absolute left-0 w-3/5 md:w-full"
                                    style={{ bottom: "-21px" }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="420"
                                    height="37"
                                    viewBox="0 0 420 37"
                                    fill="none"
                                >
                                    <path d="M1.00776 8.30987L418.667 7.78945" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M172.047 20.7032L342.803 17.4029L418.586 17.9928" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </span>{" "}
                            by switching to Gallabox
                            <svg
                                className="hidden md:inline-block"
                                style={{ right: "-14px", top: "-6px", position: "absolute" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="21"
                                viewBox="0 0 19 21"
                                fill="none"
                            >
                                <path
                                    d="M8.87276 2.93042C8.60019 5.98314 6.61593 12.0886 0.859375 12.0886C3.5305 12.7972 8.87276 15.2939 8.87276 19.6113C8.81824 17.1038 9.72316 12.0886 13.7789 12.0886C11.7619 11.7615 7.95694 9.47196 8.87276 2.93042Z"
                                    stroke="#42D15E"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M13.7879 1.15015C13.9156 2.5799 14.8449 5.43941 17.541 5.43941C16.29 5.77131 13.7879 6.94065 13.7879 8.96273C13.8134 7.78829 13.3896 5.43941 11.4901 5.43941C12.4348 5.28622 14.2168 4.2139 13.7879 1.15015Z"
                                    stroke="#42D15E"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </h2>
                    <div className="mt-9 md:mt-14">
                        <div className="wati-comp-cont mx-auto hidden md:flex">
                            <div className="side-box">
                                <div className="wati-comp-title font-medium text-gray-700 text-center">
                                    Features<span className="" style={{ fontSize: "25px" }}></span>
                                </div>
                                {WatiComparison?.map((t) => (
                                    <div key={t?.title} className="text-gray-600 font-normal text-base text-center" style={{ padding: "20px 35px", color: "#344054" }}>
                                        {t?.title}
                                    </div>
                                ))}
                            </div>

                            <div className="middle-box">
                                <div className="wati-comp-title">
                                    <img src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                                </div>
                                {WatiComparison?.map((g) => (
                                    <div key={g?.gallabox} className="text-gray-600 font-normal text-base text-center" style={{ padding: "20px 25px", color: "#344054" }}>
                                        {g?.gallabox}
                                    </div>
                                ))}
                            </div>

                            <div className="side-box">
                                <div className="wati-comp-title">
                                    <img src="comparison-page/wati-logo.png" alt="wati logo" />
                                </div>
                                {WatiComparison?.map((w) => (
                                    <div key={w?.wati} className="text-gray-600 font-normal text-base text-center" style={{ padding: "20px 35px", color: "#344054" }}>
                                        {w?.wati}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="wati-comp-mobile md:mx-2">
                            <div className="wati-comp-title font-medium text-gray-700 flex justify-center items-center">Features</div>
                            <div className="wati-comp-title flex justify-center items-center">
                                <img loading="lazy" src="comparison-page/gallabox-logo.png" height={"14px"} width="67px" alt="gallabox logo" />
                            </div>
                            <div className="wati-comp-title flex justify-center items-center">
                                <img loading="lazy" src="comparison-page/wati-logo.png" height={"22px"} width="54px" alt="wati logo" />
                            </div>
                            {WatiComparison.map((data) => (
                                <>
                                    <div>{data.title}</div>
                                    <div>{data.gallabox}</div>
                                    <div>{data.wati}</div>
                                </>
                            ))}
                        </div>
                    </div>
                    <p className="text-blue-500 text-xs md:text-base font-medium p-4 mt-3 md:mt-8 text-center">
                        Note: The pricing comparison between Gallabox vs Wati assuming the pricing plan for 10 users in the pro plan{" "}
                    </p>
                </section>
                <section className="mx-auto mt-16 pb-10" style={{ width: "100%", maxWidth: "76rem" }}>
                    <ContentBlock
                        arr={firstChatbot}
                        title={
                            <>
                                <span className="text-gray-700 font-bold relative mb-3 wati-content-head hidden md:block">
                                    <span className="green-underline relative">Launch your first Chatbot</span>
                                    {<br />} <div>within 30 seconds</div>
                                    <svg
                                        style={{ top: "-9px", right: "-29px", position: "absolute" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                                <span className="text-gray-700 font-bold relative mb-3 wati-content-head block md:hidden text-center">
                                    <span className="">Launch your first Chatbot</span>
                                    <span style={{ width: "fit-content" }} className="green-underline relative block mx-auto">
                                        within 30 seconds
                                    </span>
                                    <svg
                                        style={{ bottom: "16px", right: "18px", position: "absolute" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </>
                        }
                        img={"https://assets.gallabox.com/gb-home/new-wati/first-chatbot.png"}
                    />
                </section>
            </div>
            <section className="mx-auto mt-16 px-5" style={{ width: "100%", maxWidth: "76rem" }}>
                <div className={"flex gap-y-9 justify-between flex-wrap text-center md:text-left flex-row-reverse"}>
                    <div className="img40">
                        <div className={"wati-header-img"}>
                            <Image
                                alt="30% Less Back-and-Forth through Improved Average Handling Time"
                                className="img"
                                src={"https://assets.gallabox.com/gb-home/new-wati/better-coversion.png"}
                                layout="fill"
                            />
                        </div>
                    </div>
                    <div className="flex items-center md:items-start flex-col justify-start" style={{ width: "100%", maxWidth: "690px", zIndex: 2 }}>
                        <span className="text-gray-700 font-bold relative mb-3">
                            <div>
                                <span className="text-gray-700 font-bold relative mb-3 hidden md:block wati-content-head">
                                    <span className="green-underline relative">30% Less Back-and-Forth through </span>Improved Average Handling Time
                                    <svg
                                        style={{ top: "-9px", left: "-30px", position: "absolute", transform: "rotate(238deg)" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                                <span className="text-gray-700 font-bold relative mb-3 block md:hidden wati-content-head">
                                    <span className="">30% Less Back-and-Forth </span>through Improved Average Handling Time
                                    <svg
                                        style={{ bottom: "19px", right: "66px", position: "absolute" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                        </span>
                        <div style={{ lineHeight: "22px", color: "#444444", flexDirection: "column" }} className="md:mt-12 text-base font-normal flex gap-y-6">
                            {betterConversions?.map((obj: { txt: string; img: string }) => (
                                <div key={obj?.txt} className="flex items-center text-xs md:text-base font-normal text-gray-700">
                                    <Image src={`https://assets.gallabox.com/gb-home/new-wati/${obj?.img}.svg`} height={49} width={49} className="wati-content-img" alt="icon" />
                                    <span style={{ flexBasis: "80%" }} className="text-left ml-4 md:ml-6">
                                        {obj?.txt}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <div className="px-5" style={{ background: "linear-gradient(180deg, rgba(246,251,255,1) 95%, rgba(255,255,255,1) 100%)" }}>
                <section className="mx-auto mt-16 pt-16" style={{ width: "100%", maxWidth: "76rem" }}>
                    <ContentBlock
                        textBlkWidth={"610px"}
                        imgClassName={"img45"}
                        arr={waBroadcast}
                        title={
                            <div>
                                <span className="text-gray-700 font-bold relative wati-content-head mb-3 hidden md:block ">
                                    <span className="block" style={{ width: "102%" }}>
                                        {" "}
                                        Supercharge Your Reach with an average <span className="green-underline relative block md:inline-block">open rate of 90% </span> using
                                        WhatsApp Broadcast
                                    </span>
                                    <svg
                                        style={{ top: "-9px", right: "89px", position: "absolute" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                                <span className="text-gray-700 font-bold relative mb-3 wati-content-head block md:hidden">
                                    <span className="block" style={{ width: "102%" }}>
                                        {" "}
                                        Supercharge Your Reach {<br />} with an average <span className="green-underline relative inline-block"> open rate of 90% </span>
                                    </span>
                                    using WhatsApp Broadcast
                                    <svg
                                        style={{ top: "-3px", right: "2px", position: "absolute" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="27"
                                        height="22"
                                        viewBox="0 0 27 22"
                                        fill="none"
                                    >
                                        <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                        }
                        img={"https://assets.gallabox.com/gb-home/new-wati/wa-broadcast.png"}
                    />
                </section>
                <section className="comp-bar max-w-6xl mx-auto mt-28 md:px-0">
                    <div className="grid mb-12 hidden md:grid" style={{ gridTemplateColumns: "401px 401px 1fr", alignItems: "center" }}>
                        <div className="text-gray-800 font-semibold text-2xl flex items-center">
                            <img loading="lazy" src="https://assets.gallabox.com/gb-home/new-wati/orange-logo.svg" alt="g2 logo" />
                            Ratings
                        </div>
                        <div>
                            <img loading="lazy" src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                        </div>
                        <div>
                            <img loading="lazy" src="comparison-page/wati-logo.png" height={"45px"} width={"115px"} alt="wati logo" />
                        </div>
                    </div>
                    <div className=" block md:hidden mb-8">
                        <div className="text-gray-800 font-semibold text-2xl flex items-center  justify-center">
                            <img src="https://assets.gallabox.com/gb-home/new-wati/orange-logo.svg" alt="g2 logo" />
                            Ratings
                        </div>
                        <div className="flex items-center justify-center mt-3">
                            <img loading="lazy" height={"25px"} width="130px" src="comparison-page/gallabox-logo.png" alt="gallabox logo" />
                            <span className="mx-6 text-base">vs</span>
                            <img loading="lazy" height={"43px"} width="110px" src="comparison-page/wati-logo.png" alt="wati logo" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-7">
                        {[...barScoreOne, ...barScoreTwo].map((data) => (
                            <div key={data.title} className="barscore-box ">
                                <p className="font-normal text-base text-gray-600">{data.title}</p>
                                <div className="flex flex-wrap md:flex-nowrap gap-y-2">
                                    <div className="flex justify-center items-center mr-14">
                                        <div className="bar-cont">
                                            <div className="fill-bar" style={{ width: `${data.gallabox * 10}%` }}></div>
                                        </div>
                                        <span className="text-gray-600 text-xs md:text-base font-bold ml-6">{data.gallabox}</span>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="bar-cont-gray">
                                            <div className="fill-bar-gray" style={{ width: `${data.wati * 10}%` }}></div>
                                        </div>
                                        <span className="text-gray-600 text-xs md:text-base font-bold ml-6">{data.wati}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                <section className="mt-36 md:pb-26 pb-40">
                    <YellowCTAhref customText="Move from complex to simple WhatsApp Chatbot" />
                </section>
            </div>
        </NewLayout>
    );
};
export const ContentBlock: React.FC<{
    arr: any;
    title: any;
    img: string;
    isReverse?: boolean;
    textBlkWidth?: string;
    imgBlkWidth?: string;
    imgClassName?: string;
}> = ({ arr, title, img, isReverse = false, textBlkWidth = "590px" }) => {
    return (
        <div className={`flex gap-x-9  flex-wrap text-center md:text-left ${isReverse ? "flex-row-reverse" : ""}`}>
            <div className="img45">
                <div className={"wati-header-img"}>
                    <Image className="img" src={img} layout="fill" alt="feature image" />
                </div>
            </div>

            <div className="flex items-center md:items-start flex-col justify-center gap-2" style={{ width: "100%", maxWidth: textBlkWidth, zIndex: 2 }}>
                <span className="text-gray-700 font-bold relative mb-3" style={{ fontSize: "32px", lineHeight: "37px" }}>
                    {title}
                </span>
                <div style={{ lineHeight: "22px", color: "#444444", flexDirection: "column" }} className="mt-5 text-base font-normal flex gap-y-6">
                    {arr?.map((obj: { txt: string; img: string }) => (
                        <div key={obj?.txt} className="flex items-center text-xs md:text-base font-normal text-gray-700">
                            <Image alt="icon" src={`https://assets.gallabox.com/gb-home/new-wati/${obj?.img}.svg`} height={49} width={49} className="wati-content-img" />
                            <span style={{ flexBasis: "80%" }} className="text-left ml-4 md:ml-6">
                                {obj?.txt}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewWatiComparison;
